import React, { Component } from 'react';
import responsible from './../responsible-gaming.js';

class ResponsibleGaming extends Component {
	componentWillMount() {
		responsible.setResponsibleGamingPageActive(true);
	}

	componentWillUnmount() {
		responsible.setResponsibleGamingPageActive(false);
	}

	render() {
		return (
			<div id="responsible-gaming" />
		);
	}
}

export default ResponsibleGaming;



// WEBPACK FOOTER //
// ./mobile-core/src/components/responsible-gaming.js